import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import aboutImage from '../images/about.jpg';

const Section = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const slideInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const slideInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  return (
    <section className="py-5" id="about" aria-labelledby="about-heading">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="text-center mb-5"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 id="about-heading" className="display-4 fw-bold mb-3" style={{ color: '#b6291e' }}>
            AROGYA KUNJ HOMOEOPATHIC CLINIC
          </h2>
          <p className="lead text-muted">
            Healing With Classical Homoeopathy - Gentle, Permanent, & Holistic
          </p>
          <p style={{ color: '#b6291e' }}>
            "होम्योपैथीः-जहाँ इलाज सिर्फ लक्षणों का नहीं, बल्कि पूरी सेहत का होता है!"
          </p>
        </motion.div>

        {/* Content Row */}
        <div className="row g-4 align-items-center">
          {/* Image */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInLeft}
            viewport={{ once: true, amount: 0.2 }}
          >
            <img
              src={aboutImage}
              alt="Healthcare professionals"
              className="img-fluid rounded shadow"
            />
          </motion.div>

          {/* Text Content */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInRight}
            viewport={{ once: true, amount: 0.2 }}
          >
            <h3 className="h4 fw-semibold mb-3">DR. SHUBHAM KUMAR B.H.M.S, MD (HOMOEOPATHY)</h3>
            <p className="mb-4" style={{ color: '#02532b', textAlign: 'justify' }}>
              At AROGYAKUNJ HOMOEOPATHIC CLINIC, we follow a holistic and classical homeopathic approach to restore health naturally. Homeopathy works by stimulating the body’s innate healing power, addressing the root cause rather than just symptoms.
            </p>
            <p style={{ color: '#02532b', textAlign: 'justify' }}>
              We specialize in treating acute and chronic diseases, including allergic rhinitis, asthma, sinusitis, eczema, psoriasis, acidity, IBS, arthritis, migraine, insomnia, hormonal imbalances, male health issues, childhood disorders, and mental stress. With individualized remedies, we ensure gentle, deep, and lasting healing. Experience true holistic wellness with Dr. Shubham.
            </p>

            <Link
              to="/About"
              className="btn btn-success btn-lg"
              aria-label="Learn more about our healthcare services"
            >
              Learn More
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Section;